<ngx-spinner name="invite" [fullScreen]="true" bdColor="rgba(0,0,0,0.2)" type="ball-spin" size="default"> </ngx-spinner>
<div class="registrar-se-container" *ngIf="!validInvite">
    <mat-toolbar color="primary" class="toolbar">
        <span>&nbsp;</span>
    </mat-toolbar>

    <mat-card class="card">
        <mat-card-header class="header">
            <mat-card-title class="title">
                {{ "REGISTER_INVITE.INVALID_TOKEN.TITLE" | translate }}
            </mat-card-title>
            <mat-card-subtitle class="subtitle">
                {{ "REGISTER_INVITE.INVALID_TOKEN.SUBTITLE" | translate }}
            </mat-card-subtitle>
        </mat-card-header>
    </mat-card>
</div>
